var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberCircleZero = function SvgIconNumberCircleZero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5c-1.267 0-2.291.77-2.953 1.763C8.38 9.263 8 10.588 8 12s.38 2.737 1.047 3.737C9.709 16.73 10.733 17.5 12 17.5s2.291-.77 2.953-1.763C15.62 14.737 16 13.412 16 12s-.38-2.737-1.047-3.737C14.291 7.27 13.267 6.5 12 6.5M10 12c0-1.073.292-1.999.71-2.627.424-.636.9-.873 1.29-.873s.866.237 1.29.873C13.707 10 14 10.927 14 12s-.292 1.999-.71 2.627c-.424.636-.9.873-1.29.873s-.866-.237-1.29-.873C10.293 14 10 13.073 10 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0"
  }))));
};
export default SvgIconNumberCircleZero;